import resnexus1 from '../../../img/resnexus/1.jpg'
import resnexus2 from '../../../img/resnexus/2.jpg'
import HelpDialog from './HelpDialog'
import styles from './HelpDialogs.module.scss'

const { subNumber } = styles

const ResnexusHelpDialog = props => (
  <HelpDialog {...props} title="How to export guest data from Resnexus">
    <section>
      <p>
        <span className={subNumber}>1.</span> Select <strong>Guests By Date</strong> from
        reports page.
      </p>
      <img src={resnexus1} alt="" />
    </section>
    <section>
      <p>
        <span className={subNumber}>2.</span>Set the dates to{' '}
        <strong>one year before from now</strong>.
      </p>
    </section>
    <section>
      <p>
        <span className={subNumber}>3.</span>Click on <strong>export button</strong>.
      </p>
      <img src={resnexus2} alt="" />
    </section>
  </HelpDialog>
)

export default ResnexusHelpDialog
